import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import { DialogContent, IconButton, Paper, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { useIsDiffMode } from "src/components/DocViewer/components/hooks/useIsDiffMode";
import { Document, DocumentVersion } from "../../../../stores/models";
import ApproversTab from "./approversTab/ApproversTab";

export const DocInfoDrawer = ({
  isOpen,
  onDrawerClose,
  selectedDocVersion,
  selectedDoc,
  deviceId,
  onBeforeSubmitApproval,
}: {
  isOpen: boolean;
  onDrawerClose: () => void;
  selectedDocVersion: DocumentVersion;
  selectedDoc: Document;
  deviceId: string;
  onBeforeSubmitApproval?: () => Promise<void>;
}) => {
  const { isDiffMode } = useIsDiffMode();
  const [isEditMode, setIsEditMode] = useState(false);

  useEffect(() => {
    setIsEditMode(false);
  }, [isOpen, selectedDocVersion.id]);

  if (!isOpen || isDiffMode) {
    return null;
  }

  const isEditApprovalDisabled =
    selectedDocVersion.revision !== null || isEditMode;
  const actions = (
    <div className="flex items-center gap-1">
      <Tooltip title="Edit approval">
        <span>
          <IconButton
            aria-label="edit approval"
            disabled={isEditApprovalDisabled}
            onClick={() => setIsEditMode(true)}
          >
            <EditIcon />
          </IconButton>
        </span>
      </Tooltip>
      <IconButton aria-label="close" onClick={onDrawerClose}>
        <CloseIcon />
      </IconButton>
    </div>
  );

  return (
    <div
      className={`animate-in zoom-in absolute bottom-4 left-0 right-0 flex w-full justify-center z-50`}
    >
      <Paper
        elevation={10}
        className="h-fit w-11/12 rounded-lg border border-solid border-slate-200 bg-white p-4 shadow-xl relative flex flex-col max-h-[82vh]"
      >
        <DialogContent className="tiptap-approval-drawer__content w-full flex flex-col justify-between p-0">
          <div className="tiptap-approval-drawer__tab">
            <ApproversTab
              selectedDocVersion={selectedDocVersion}
              selectedDoc={selectedDoc}
              deviceId={deviceId}
              isEditMode={isEditMode}
              setIsEditMode={setIsEditMode}
              onBeforeSubmitApproval={onBeforeSubmitApproval}
              actions={actions}
            />
          </div>
        </DialogContent>
      </Paper>
    </div>
  );
};

export default DocInfoDrawer;
